<mat-dialog-content class="ai-asetukset-dialog" style="padding: 0">
  <div class="ai-asetukset-header">
    <span class="ai-asetukset-tahti">
      <mat-icon>auto_awesome</mat-icon>
    </span>
    <div class="ai-asetukset-otsikko">
      <h2>AI-kirjausehdotusten asetukset</h2>
      <div class="ai-asetukset-alaotsikko">Muutokset koskevat vain tätä asiakasta</div>
    </div>
    <app-button mat-dialog-close actionId="Sulje (ai-asetukset dialog)" styles="position: absolute; right: 18px; top: 16px; min-width: 0; padding: 0;">
      <i style="font-size: 40px; width: 40px; height: 40px; line-height: 40px; display: inline-block" class="icon ion-ios-close"></i>
    </app-button>
  </div>

  @if (ladataan()) {
    <div style="text-align: center; padding: 40px 0">
      <mat-spinner style="margin: 0 auto" [diameter]="36"></mat-spinner>
    </div>
  } @else {
    <form novalidate class="ai-asetukset-runko">
      <div class="ai-asetukset-vasen">
        <div class="ai-asetukset-kaytossa">
          <mat-slide-toggle [formField]="lomake.kaytossa"> <strong>AI-kirjausehdotukset käytössä</strong> </mat-slide-toggle>
        </div>

        <div class="ai-asetukset-osio-otsikko">Kirjaustyypit joille ehdotuksia tehdään</div>

        <mat-checkbox [checked]="kaikkiValittu()" [indeterminate]="kaikkiOsittain()" (change)="vaihdaKaikki()">
          <strong>Kaikki kirjaustyypit</strong><span class="ai-asetukset-maara">({{ valitutMaara() }}/{{ kategoriat.length }})</span>
        </mat-checkbox>

        <div class="ai-asetukset-tyyppilista">
          @for (kategoria of kategoriat; track kategoria) {
            <mat-checkbox [checked]="onKategoriaValittu(kategoria)" (change)="vaihdaKategoria(kategoria)"> {{ otsikot[kategoria] }} </mat-checkbox>
          }
        </div>

        <div class="ai-asetukset-auto">
          <mat-slide-toggle [formField]="lomake.automaattihyvaksynta"> Hyväksy luotettavat ehdotukset automaattisesti </mat-slide-toggle>
        </div>

        <div class="ai-asetukset-backfill">
          <div class="ai-asetukset-osio-otsikko">Takautuvat ehdotukset</div>
          @if (backfillKaynnissa()) {
            <div class="ai-asetukset-backfill-tila">Takautuva ajo on käynnissä.</div>
          } @else if (backfillMaara() !== null) {
            <div class="ai-asetukset-backfill-tila">{{ backfillMaara() }} hyväksymätöntä kirjausta ilman ehdotusta.</div>
          }
          <app-secondary-button (click)="kaynnistaBackfill()" [disabled]="backfillNappiDisabloitu()" actionId="Käynnisti takautuvan AI-kirjausehdotusajon">Tee ehdotukset olemassa oleville</app-secondary-button>
        </div>
      </div>

      <div class="ai-asetukset-oikea">
        <div class="ai-asetukset-osio-otsikko">Asiakaskohtainen ohjeistus</div>
        <mat-form-field style="width: 100%">
          <textarea matInput rows="14" [formField]="lomake.lisaohje" [placeholder]="lisaohjePlaceholder"></textarea>
          <mat-hint align="end">{{ lomake.lisaohje().value().length || 0 }} / {{ lisaohjeMax }} merkkiä</mat-hint>
          @if (onkoVirhe(lomake.lisaohje, 'maxLength') && (lomake.lisaohje().dirty() || lomake.lisaohje().touched())) {
            <mat-error> Ohjeistus on liian pitkä </mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions class="ai-asetukset-footer">
  <span class="ai-asetukset-tila">{{ ladataan() ? '' : onMuuttunut() ? 'Muutoksia tallentamatta' : 'Ei muutoksia' }}</span>
  <span style="display: flex; gap: 8px">
    <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (ai-asetukset dialog)">Peruuta</app-secondary-button>
    <app-primary-button (click)="tallenna()" [disabled]="tallennetaan() || ladataan()" actionId="Tallensi AI-kirjausehdotusten asetukset">Tallenna</app-primary-button>
  </span>
</mat-dialog-actions>
